import React from 'react';

// showing this inline so that it renders with the correct font
const MouseDiagram = () => (
  <svg viewBox="0 0 279 150" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Mockups" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Watch-Game-(Single,-Live,-Manual-Tracking)-2"
        transform="translate(-1577.000000, -649.000000)"
      >
        <g id="Group-6" transform="translate(1577.000000, 649.000000)">
          <text
            id="Zoom-Out-(f)"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="14"
            fontWeight="400"
            letterSpacing="0.1"
            fill="#FFFFFF"
            fillOpacity="0.7"
          >
            <tspan x="197.20127" y="59">
              Zoom Out (f)
            </tspan>
          </text>
          <g
            id="noun-mouse-1003593"
            transform="translate(90.000000, 0.000000)"
            fill="#FFFFFF"
            fillOpacity="0.7"
            fillRule="nonzero"
          >
            <path
              d="M88.2598715,0.010915915 C87.3596153,0.150819264 86.7167446,0.957401529 86.7850414,1.86371188 C87.0961058,9.01708889 84.8356937,12.5730669 81.5932971,13.9636293 C78.3508381,15.3541294 73.5141623,14.5439283 68.4773116,11.238563 C62.6488174,7.41381557 56.0811438,7.31633605 51.2076183,10.5840487 C46.8050191,13.5366192 43.9116951,19.0744212 43.7199519,26.3894335 L24.2092988,26.3894335 C10.9065666,26.3894335 0,37.2993534 0,50.642524 L0,104.327888 C0,129.426528 20.4475092,150 45.46875,150 C70.4734396,150 90.9375,129.426839 90.9375,104.327888 L90.9375,50.642524 C90.9375,37.2993534 80.0684077,26.3894335 66.781602,26.3894335 L47.2175481,26.3894335 C47.3932086,20.0037466 49.8244127,15.68257 53.119117,13.4719962 C56.7834736,11.0145781 61.6801082,10.9768632 66.5633145,14.1800152 C72.2381643,17.9038572 78.1850146,19.2237237 82.9582965,17.1775881 C87.7315784,15.1313592 90.6298989,9.7018747 90.2810762,1.69952274 L90.2810762,1.70073921 C90.254239,0.799287262 89.54427,0.066914004 88.641578,0.0109489273 C88.514712,-0.00364964242 88.3866251,-0.00364964242 88.2585287,0.0109489273 L88.2598715,0.010915915 Z M24.210142,29.8770202 L43.7207951,29.8770202 L43.7207951,36.1994855 C40.0074097,37.024293 37.2177645,40.323523 37.2177645,44.265059 L37.2177645,71.9511102 C37.2177645,75.8926461 40.0051613,79.2430763 43.7207951,80.0714964 L43.7207951,95.3879265 C43.7146955,95.8550807 43.8964556,96.3051994 44.2246051,96.6373149 C44.5527546,96.9694304 45.0016648,97.1567904 45.4700928,97.1567904 C45.9385209,97.1567904 46.3874311,96.9694428 46.7155806,96.6373149 C47.04373,96.3051994 47.2254801,95.8550807 47.2193906,95.3879265 L47.2193906,80.1275549 C50.9583833,79.3246414 53.7773833,75.9169381 53.7773833,71.9523559 L53.7773833,44.2663047 C53.7773833,40.3017225 50.9558226,36.9450637 47.2193906,36.1459185 L47.2193906,29.8782659 L66.7834445,29.8782659 C78.1478214,29.8782659 87.4404972,39.1861582 87.4404972,50.6435829 L87.4404972,104.328947 C87.4404972,127.539349 68.5509797,146.512974 45.4693433,146.512974 C22.3699067,146.512974 3.4981895,127.539661 3.4981895,104.328947 L3.4981895,50.6435829 C3.4981895,39.1861582 12.827715,29.8782659 24.2102044,29.8782659 L24.210142,29.8770202 Z M45.4686563,39.4695651 C48.1035641,39.4695651 50.2772265,41.5972969 50.2772265,44.265059 L50.2772265,71.9511102 C50.2772265,74.6189968 48.0973184,76.8014168 45.4686563,76.8014168 C42.8178844,76.8014168 40.713487,74.6189345 40.713487,71.9511102 L40.713487,44.265059 C40.713487,41.5971723 42.8116699,39.4695651 45.4686563,39.4695651 L45.4686563,39.4695651 Z"
              id="Shape"
            />
          </g>
          <text
            id="Zoom-In-(r)"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="14"
            fontWeight="400"
            letterSpacing="0.1"
            fill="#FFFFFF"
            fillOpacity="0.7"
          >
            <tspan x="0.521777344" y="34">
              Zoom In (r)
            </tspan>
          </text>
          <rect id="Rectangle" stroke="#FFFFFF" x="0.5" y="45.5" width="118" height="1" />
          <rect id="Rectangle" stroke="#FFFFFF" x="151.5" y="70.5" width="127" height="1" />
        </g>
      </g>
    </g>
  </svg>
);

export default React.memo(MouseDiagram);
